export default __webpack_public_path__ + "static/media/sslCommerz-images.c35b5eef.webp";